import * as Popover from "@radix-ui/react-popover";
import { useState } from "react";
import { cn } from "@/lib/cn";

export interface OpcionDesarrollo {
  id: number;
  nombre: string;
}

export interface SelectorDesarrolloProps {
  desarrollos: OpcionDesarrollo[];
  actual: number;
  onElegir: (id: number) => void;
  /** Si viene, el menú termina en "Nuevo desarrollo". */
  onNuevo?: () => void;
}

/** Nombre del desarrollo en el header, desplegable para cambiar de desarrollo o crear uno nuevo. */
export function SelectorDesarrollo({ desarrollos, actual, onElegir, onNuevo }: SelectorDesarrolloProps) {
  const [abierto, setAbierto] = useState(false);
  const nombre = desarrollos.find((d) => d.id === actual)?.nombre ?? "";
  return (
    <Popover.Root open={abierto} onOpenChange={setAbierto}>
      <Popover.Trigger asChild>
        <button
          type="button"
          aria-label={`Desarrollo: ${nombre}`}
          className="flex min-w-0 items-center gap-1 rounded-control px-1 py-1 text-[1.25rem] font-light tracking-[-0.02em] hover:bg-superficie-2"
        >
          <span className="truncate">{nombre}</span>
          <span aria-hidden="true" className="text-texto-suave">
            ▾
          </span>
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content align="start" sideOffset={6} className="z-50 min-w-56 rounded-tarjeta border border-borde bg-superficie p-1 shadow-flotante">
          <ul aria-label="Desarrollos" className="flex flex-col">
            {desarrollos.map((d) => (
              <li key={d.id}>
                <button
                  type="button"
                  aria-current={d.id === actual ? "true" : undefined}
                  onClick={() => {
                    setAbierto(false);
                    if (d.id !== actual) onElegir(d.id);
                  }}
                  className={cn(
                    "block w-full truncate rounded-control px-3 py-2 text-left hover:bg-superficie-2",
                    d.id === actual && "bg-primario-suave font-medium text-primario",
                  )}
                >
                  {d.nombre}
                </button>
              </li>
            ))}
          </ul>
          {onNuevo && (
            <button
              type="button"
              onClick={() => {
                setAbierto(false);
                onNuevo();
              }}
              className="mt-1 block w-full rounded-control border-t border-borde px-3 py-2 text-left text-primario hover:bg-superficie-2"
            >
              + Nuevo desarrollo
            </button>
          )}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
